import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Field, Fields, FormSection } from 'redux-form';
import { PROFESSIONAL_POSITION_CANDIDATES } from '../../../../define/consts/profile';
import { propBool, propStr } from '../../../../helpers/custom-prop-types';
import { validateImageFile } from '../../../../validate/common';
import { consultantValidate } from '../../../../validate/custom/profile';
import { validateAddress1, validateAddress2, validateAddress3, validateDepartment, validatePhoneNumber, validateZipCode1NoRequired, validateZipCode2NoRequired, } from '../../../../validate/profile';
import PlainInputComponent from '../../../Ui/Common/PlainInputComponent';
import FileFieldAndLabel from '../../../Ui/Profile/Hook/FileFieldsAndLabel';
import OrganizationFieldsAndLabel from '../../../Ui/Profile/Hook/OrganizationFieldsAndLabel';
import PhoneNumberFields from '../../../Ui/Profile/Hook/PhoneNumberFields';
import PositionFieldsAndLabel from '../../../Ui/Profile/Hook/PositionFieldsAndLabel';
import ProfessionalAddressFieldsAndLabel from '../../../Ui/Profile/ProfessionalAddressFieldsAndLabel';
const OrganizationSection = (props) => {
    const { form, useProffit, useProffitMart } = props;
    const viewPosition = useMemo(() => [{ label: '---', value: '' }, ...PROFESSIONAL_POSITION_CANDIDATES], []);
    const { addressNames, addressValidate, organizationNames, organizationValidate, phoneNames, phoneValidate, positionNames, positionValidate, } = useMemo(() => ({
        addressNames: [
            'zipCode1',
            'zipCode2',
            'prefecture',
            'address1',
            'address2',
            'address3',
        ],
        addressValidate: {
            address1: validateAddress1,
            address2: validateAddress2,
            address3: validateAddress3,
            zipCode1: validateZipCode1NoRequired,
            zipCode2: validateZipCode2NoRequired,
        },
        organizationNames: [
            'organizationCandidate',
            'organization',
            'organizationId',
            'otherOrganization',
        ],
        organizationValidate: {
            organizationId: consultantValidate.organization.organizationId,
            otherOrganization: consultantValidate.organization.organizationOther('0'),
        },
        phoneNames: ['phone1', 'phone2', 'phone3'],
        phoneValidate: {
            phone1: validatePhoneNumber,
            phone2: validatePhoneNumber,
            phone3: validatePhoneNumber,
        },
        positionNames: ['position', 'positionOther'],
        positionValidate: {
            position: consultantValidate.position.position,
            positionOther: consultantValidate.position.positionOther(PROFESSIONAL_POSITION_CANDIDATES.find((v) => v.other).value),
        },
    }), []);
    return (_jsxs("div", Object.assign({ className: 'form-inputarea content-box' }, { children: [_jsx("h3", { children: "\u6240\u5C5E\u3059\u308B\u7D44\u7E54\u306B\u3064\u3044\u3066" }), _jsxs("div", Object.assign({ className: 'content-box-inner form-inputarea-inner' }, { children: [_jsx(FormSection, Object.assign({ name: 'information' }, { children: _jsx(Field, { alt: '', component: FileFieldAndLabel, description: '※Proffit運営の確認用です。ユーザーには公開されません。', label: '名刺', name: 'cardPhoto', noImageType: 'user', validate: validateImageFile }) })), useProffit && (_jsx(Fields, { component: OrganizationFieldsAndLabel, names: organizationNames, validate: organizationValidate })), _jsxs(FormSection, Object.assign({ name: 'information' }, { children: [(useProffit || useProffitMart) && (_jsx(Fields, { component: ProfessionalAddressFieldsAndLabel, formName: form, names: addressNames, validate: addressValidate })), _jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u90E8\u7F72" }), _jsx(Field, { className: 'input-form-text is-half-one', component: PlainInputComponent, name: 'department', placeholder: '部署名', validate: validateDepartment })] })), _jsx(Fields, { component: PositionFieldsAndLabel, names: positionNames, options: viewPosition, validate: positionValidate }), _jsxs("div", Object.assign({ className: 'form form-solution req' }, { children: [_jsx("h3", { children: "\u3054\u9023\u7D61\u5148" }), _jsx(Fields, { component: PhoneNumberFields, names: phoneNames, validate: phoneValidate })] }))] }))] }))] })));
};
OrganizationSection.propTypes = {
    form: propStr().isRequired,
    useProffit: propBool().isRequired,
    useProffitMart: propBool().isRequired,
};
export default OrganizationSection;
